import T from '../types';

export default ({ width }) => ({
  type: T.UPDATE_VIEWPORT,
  width,
});
